class States {
  /**
   * @public
   * @returns {Array<string>}
   * @description Get states.
   */
  static getStates () {
    return [...States.getUsaStates(), ...States.getCanadaStates()]
  }

  /**
   * @public
   * @param {string} stateId
   * @returns {string}
   * @description Get state display.
   */
  static getStateDisplay (stateId) {
    return { ...States._usaStateId_to_stateDisplay, ...States._canadaStateId_to_stateDisplay }[stateId]
  }

  /**
   * @public
   * @returns {Array<string>}
   * @description Get usa states.
   */
  static getUsaStates () {
    return Object.keys(States._usaStateId_to_stateDisplay)
  }

  /**
   * @public
   * @param {string} stateId
   * @returns {string}
   * @description Get usa state display.
   */
  static getUsaStateDisplay (stateId) {
    return States._usaStateId_to_stateDisplay[stateId]
  }

  /**
   * @public
   * @returns {Array<string>}
   * @description Get canada states.
   */
  static getCanadaStates () {
    return Object.keys(States._canadaStateId_to_stateDisplay)
  }

  /**
   * @public
   * @param {string} stateId
   * @returns {string}
   * @description Get canada state display.
   */
  static getCanadaStateDisplay (stateId) {
    return States._canadaStateId_to_stateDisplay[stateId]
  }
}

States._usaStateId_to_stateDisplay = {
  AA: 'Armed Forces Americas',
  AE: 'Armed Forces Europe',
  AK: 'Alaska',
  AL: 'Alabama',
  AP: 'Armed Forces Pacific',
  AR: 'Arkansas',
  AS: 'American Samoa',
  AZ: 'Arizona',
  CA: 'California',
  CAWC: 'California Workers Comp Forms',
  CMPT: 'Interstate Insurance Compact',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District Of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  IA: 'Iowa',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MA: 'Massachusetts',
  MD: 'Maryland',
  MDWC: 'Marylandwcc',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MI: 'Michigan',
  MN: 'Minnesota',
  MO: 'Missouri',
  MS: 'Mississippi',
  MT: 'Montana',
  NC: 'North Carolina',
  ND: 'North Dakota',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NP: 'Northern Mariana Islands',
  NV: 'Nevada',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VA: 'Virginia',
  VI: 'US Virgin Islands',
  VT: 'Vermont',
  WA: 'Washington',
  WI: 'Wisconsin',
  WV: 'West Virginia',
  WVFC: 'West Virginia FC',
  WY: 'Wyoming'
}

States._canadaStateId_to_stateDisplay = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon'
}

module.exports = States
